import { BrowserRouter, Switch, Route } from "react-router-dom";

import LocalhostHome from "../pages/LocalhostHome";
import LocalhostAll from "../pages/LocalhostAll";
import TestnetHome from "../pages/TestnetHome";
import TestnetAll from "../pages/TestnetAll";
import MainnetHome from "../pages/MainnetHome";
import MainnetAll from "../pages/MainnetAll";
import NotFound from "../pages/NotFound";

export default function Router() {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/">
                    <MainnetHome />
                </Route>
                <Route exact path="/all">
                    <MainnetAll />
                </Route>
                <Route exact path="/test">
                    <TestnetHome />
                </Route>
                <Route exact path="/test-all">
                    <TestnetAll />
                </Route>
                <Route exact path="/local">
                    <LocalhostHome />
                </Route>
                <Route exact path="/local-all">
                    <LocalhostAll />
                </Route>
                <Route path="*">
                    <NotFound />
                </Route>
            </Switch>
        </BrowserRouter>
    );
}
